import { FaArrowLeft } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import {
  LANDING_WHATSAPP_CONTEXT,
  resolveLandingWhatsAppCta,
} from "../../utils/landingWhatsapp";
import "../common/HeroSection.css";
import "./LandingProductCard.css";

function LandingProductCard({ product, image, className = "", style }) {
  const { t } = useTranslation();
  const { title, description, ctaText } = product;
  const ctaLabel = ctaText || t("Request a Quote");
  const ctaLink = resolveLandingWhatsAppCta(t, LANDING_WHATSAPP_CONTEXT.PRODUCT, {
    product: title,
  });

  const imageUrl = image?.url;
  const imageAlt = image?.alt || title;

  return (
    <article className={`landing-product-card ${className}`.trim()} style={style}>
      <div className="landing-product-card__media">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={imageAlt}
            className="landing-product-card__image"
            width={image?.width || undefined}
            height={image?.height || undefined}
            loading="lazy"
            decoding="async"
          />
        ) : (
          <div className="landing-product-card__placeholder" aria-hidden="true" />
        )}
        <span className="landing-product-card__badge">{t("Product")}</span>
      </div>

      <div className="landing-product-card__content">
        <h3 className="landing-product-card__title">{title}</h3>
        {description ? (
          <p className="landing-product-card__excerpt">{description}</p>
        ) : null}
      </div>

      <div className="landing-product-card__footer">
        <a
          href={ctaLink.href}
          className="hero-btn hero-btn--primary landing-product-card__cta-btn"
          target={ctaLink.target}
          rel={ctaLink.rel}
        >
          <span className="hero-btn__label">{ctaLabel}</span>
          <span className="hero-btn__icon-wrap" aria-hidden="true">
            <FaArrowLeft className="hero-btn__icon" />
          </span>
        </a>
      </div>
    </article>
  );
}

export default LandingProductCard;
